import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-drafts-toggle-button',
    templateUrl: './drafts-toggle-button.component.html',
    styleUrls: ['./drafts-toggle-button.component.scss'],
    standalone: false
})
export class DraftsToggleButtonComponent {
    @Input() draftCount = 0;
    @Input() showDrafts = false;
    @Output() showDraftsChange = new EventEmitter<boolean>();

    get badgeDigitCount(): number {
        return this.draftCount?.toString().length || 1;
    }

    toggle(): void {
        this.showDrafts = !this.showDrafts;
        this.showDraftsChange.emit(this.showDrafts);
    }
}
